document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_ModalCart', ({ openOnAddToCart }) => {
    return {
      init() {
        if (openOnAddToCart === true) {
          document.body.addEventListener(
            'shapes:modalcart:afteradditem',
            () => {
              Alpine.store('modals').open('cart');
            }
          );
        }

        Alpine.store('modals').register('cart', 'rightDrawer');
      },
      async addUpsellToCart(variantId) {
        const config = fetchConfigDefaults('javascript');
        config.body = JSON.stringify({
          id: variantId,
          quantity: 1,
          sections: 'cart-items,cart-footer',
          sections_url: window.location.pathname,
        });

        try {
          const response = await fetch(theme.routes.cart_add_url, config);
          const data = await response.json();

          if (data.status && data.status === 422) {
            console.error(data.message);
            alert(theme.strings.cartError);
            return;
          }

          document.body.dispatchEvent(
            new CustomEvent('shapes:modalcart:afteradditem', {
              bubbles: true,
              detail: { response: data },
            })
          );
        } catch (error) {
          console.error(error);
          alert(theme.strings.cartError);
        }
      },
    };
  });
});
